module.exports = __webpack_public_path__ + "static/media/surprise-meal3.91bde1db.png";